<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-progress-linear
        v-if="loading && items.length > 0"
        absolute
        indeterminate
    />
    <v-progress-linear
        v-model="progress"
        absolute
        bottom
        color="white"
    />
    <v-carousel
        v-if="items.length > 0"
        :cycle="cycle"
        :interval="cycleInterval"
        :show-arrows="showArrows"
        @change="onChange"
        height="100%"
        hide-delimiters
    >
      <v-carousel-item
          v-for="(item, index) in items"
          :key="index"
      >
        <!-- <video-background
            v-if="item.video && item.video.url"
            :src="item.video.url"
            style="height: 100%"
        >
          <v-row align="end" class="fill-height pa-6 pa-md-8 pa-lg-10 pa-xl-12">
            <v-col cols="12">
              <v-row align="center" justify="start" no-gutters class="pa-3">
                <v-col v-if="item.creator.image" cols="auto">
                  <v-avatar :size="avatarSize" tile class="rounded">
                    <v-img :src="item.creator.image.url" />
                  </v-avatar>
                </v-col>
                <v-col cols="auto" class="ml-3">
                  <v-row no-gutters class="text-left">
                    <v-col cols="12">
                      <span class="text-creator">{{ item.creator.name }}</span>
                    </v-col>
                    <v-col cols="12" class="mt-n2">
                      <span class="text-time">{{ new Date(item.pubdate) | moment('from', 'now') }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row align="end" no-gutters class="pa-3">
                <v-col class="text-title text-left" style="padding-right: 250px">
                  {{ item.title }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </video-background> -->
        <v-img
            v-if="item.cover"
            :src="item.cover"
            class="blur"
            gradient="to bottom, rgba(15, 35, 25, .4), rgba(15, 35, 25, 1)"
            height="100%"
        >
          <template v-slot:placeholder>
            <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
            >
              <v-progress-circular indeterminate color="white"></v-progress-circular>
            </v-row>
          </template>
          <v-row align="end" class="fill-height pa-6 pa-md-8 pa-lg-10 pa-xl-12">
            <v-col cols="12">
              <v-row align="center" justify="start" no-gutters class="pa-3">
                <v-col v-if="item.favicon" cols="auto">
                  <v-avatar :size="avatarSize" tile class="rounded">
                    <v-img :src="item.favicon" />
                  </v-avatar>
                </v-col>
                <v-col cols="auto" class="ml-3">
                  <v-row no-gutters class="text-left">
                    <v-col cols="12">
                      <span class="text-creator">{{ item.domain }}</span>
                    </v-col>
                    <v-col cols="12" class="mt-n2">
                      <span class="text-time">{{ new Date(item.created) | moment('from', 'now') }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row align="end" no-gutters class="pa-3">
                <v-col class="text-title text-left" style="padding-right: 250px" >
                  {{ unescapeHtmlEntities(item.title) }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-img>
        <qrcode
            v-if="item.link || item.url"
            :value="item.link || item.url"
            :options="{ width: qrCodeWidth }"
            class="ma-6 ma-md-8 ma-lg-10 ma-xl-12 rounded"
            style="position: absolute; bottom: 0; right: 0;"
        />
      </v-carousel-item>
    </v-carousel>
    <v-row
        v-else-if="loading"
        class="fill-height ma-0"
        align="center"
        justify="center"
    >
      <v-progress-circular indeterminate color="white"></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ScreenHome',
  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    showArrows: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    animationStepValue() {
      const fps = 1000 / this.animateInterval;
      const frames = fps * (this.cycleInterval / 1000);
      return 100 / frames;
    },
    avatarSize() {
      if (this.$vuetify.breakpoint.width > 1920) {
        return 128;
      } else if (this.$vuetify.breakpoint.width > 1280) {
        return 96;
      } else {
        return 64;
      }
    },
    configurationId() {
      return this.$route.query.c || '636a2cd2d3a649c3462eab0a';
    },
    qrCodeWidth() {
      return this.$vuetify.breakpoint.lgAndDown ? 200 : 250;
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      cycleInterval: 20000,
      updateInterval: 600000, // 10 minutes
      progress: 0,
      progressInterval: null,
      animateInterval: 100
    }
  },
  mounted() {
    this.fetchBookmarks();
    setInterval(() => {
      this.fetchBookmarks();
    }, this.updateInterval);
  },
  methods: {
    fetchBookmarks() {
      fetch("/api/v1/feed")
        .then((res) => res.json())
        .then((data) => {
          console.log("Bookmarks:", data);
          this.items = data || [];
          console.log(this.items)
          this.cycleInterval =
              data.cycleInterval || this.cycleInterval;
          this.startAnimation();
        })
        .catch((err) => {
          console.error("Fehler beim Laden:", err);
        });
    },
    onChange() {
      this.progress = 100;
    },
    startAnimation() {
      if (!this.progressInterval) {
        setInterval(() => {
          this.progress -= this.animationStepValue;
        }, this.animateInterval);
      }
    },
    unescapeHtmlEntities(str) {
      const tempElement = document.createElement('textarea');
      tempElement.innerHTML = str;
      return tempElement.value;
    } 
  }
}
</script>

<style scoped lang="scss">

  .text-time {
    font-size: 3rem;
    line-height: 3rem;
    letter-spacing: -0.05rem;
  }

  .text-creator {
    font-size: 6rem;
    font-weight: bold !important;
    line-height: 6rem;
    letter-spacing: -0.05rem;
    text-transform: uppercase;
  }

  .text-title {
  font-size: 14rem;
  font-weight: bold;
  line-height: 14rem;
  letter-spacing: -0.1rem;
  text-transform: uppercase;
}



  @media (orientation: portrait) {
  .text-title {
    font-size: 10rem !important;
    line-height: 10rem !important;
    max-width: 85%;
  }
  }

  @media (orientation: landscape) {
  .text-title {
    font-size: 12rem !important;
    line-height: 12rem !important;
  }
  }

   @media only screen and (max-width: 1920px) {
    .text-time {
      font-size: 2rem;
      line-height: 2rem;
      letter-spacing: -0.05rem;
    }

    .text-creator {
      font-size: 3rem;
      line-height: 3rem;
    }

    .text-title {
      font-size: 6rem !important;
      line-height: 6rem !important;
    }
  }




</style>
